<div class="container-main">
  <div>
    <member-member-detail-header [useCustomerId]="true"></member-member-detail-header>
  </div>
  <div *ngIf="hasConflict; else showOutlet" class="conflict-header">
    <span>Member conflict</span>
  </div>
  <ng-template #showOutlet>
    <div class="route-container">
      <router-outlet></router-outlet>
    </div>
  </ng-template>
</div>
